import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function Footer() {
  return (
    <Box component="footer" sx={{ p: 2, bgcolor: '#F2EFE8', color: 'black' }}>
      <Typography variant="h6" align="center">
        © 2024 Tom-House
      </Typography>
    </Box>
  );
}

export default Footer;